// Anmeldeprobe (Schlusslauf 3, 10.10.2026): die Regel für ein neues Passwort in einem Satz, an jeder Stelle, an der eines
// gesetzt wird (Einladung annehmen, „Neues Passwort“ nach „Passwort vergessen“, „Passwort ändern“). Geprüft wird sie vom
// Server (backend/src/utils/passwordValidator.ts); er nennt je Versuch nur den ersten Mangel, darum steht sie vorher da.
export const PASSWORT_REGEL = 'Mindestens 8 Zeichen mit Groß- und Kleinbuchstaben, Zahl und Sonderzeichen.';
